import { Avatar, Box, Flex, Checkbox } from '@chakra-ui/react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { CheckCircle } from '@kula-ai/icons-core';
import '@/components/formBuilder/styles/checkbox.css';

export const FilterItemCheckBox = ({
  onSelect = () => {},
  isSelected = false,
  label = '',
  avatarSrc = '',
  avatarName = '',
  showAvatar = false,
  rightElement = null,
  maxLabelWidth = '230px',
  item = {},
  renderItem = null,
}) => {
  return (
    <Flex
      alignItems="center"
      borderRadius="8px"
      padding="8px"
      cursor="pointer"
      onClick={() => onSelect()}
      _hover={{ bg: 'secondary-50', fontWeight: 550 }}
      flex="1"
    >
      <Flex flex="1" gap="6px" alignItems="center">
        <Box
          onClick={(e) => {
            e?.stopPropagation();
          }}
          w="14px"
          h="14px"
          mr="8px"
        >
          <Checkbox
            className="checkbox-md custom_checkbox"
            isChecked={isSelected}
            onChange={() => onSelect()}
          />
        </Box>
        {renderItem ? renderItem(item) : null}
        {showAvatar && (
          <Avatar
            borderRadius="full"
            width="22px"
            height="22px"
            className="avatar-sm"
            src={avatarSrc}
            name={avatarName}
          />
        )}
        <TruncatedTextWithTooltip
          fontSize="sm"
          ml="8px"
          fontWeight={isSelected ? 550 : 450}
          color={isSelected ? 'primary-500' : 'secondary-900'}
          text={label}
          maxW={maxLabelWidth}
          enableTooltip={true}
        />
        {rightElement ? rightElement : null}
      </Flex>
      {isSelected && (
        <CheckCircle
          size="1em"
          color="var(--kula-colors-primary-500)"
          className="kula-icon"
        />
      )}
    </Flex>
  );
};
